var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "search-component",
      attrs: { "grid-list-md": "", fluid: "", "px-2": "", "py-1": "" },
    },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "panel",
                {
                  staticClass: "query-panel d-flex fill-height",
                  attrs: { "fill-height": "" },
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _vm.$vuetify.breakpoint.smAndDown
                        ? [
                            _vm._v(
                              "\n                MSTA proteins\n            "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n                Input protein structures (PDB/CIF) for MSTA\n            "
                            ),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "toolbar-extra" },
                    [
                      _vm.queries.length > 0
                        ? _c(
                            "v-icon",
                            {
                              staticStyle: { "margin-right": "16px" },
                              attrs: { title: "Clear" },
                              on: {
                                click: function ($event) {
                                  _vm.queries = []
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$MDI.Delete))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      { staticClass: "upload-outer-container w-44 gr-2 mb-2" },
                      [
                        _c(
                          "v-alert",
                          {
                            attrs: {
                              border: "left",
                              "close-text": "Close Alert",
                              color: "primary",
                              text: "",
                              type: "info",
                              dismissible: "",
                            },
                            model: {
                              value: _vm.alert,
                              callback: function ($$v) {
                                _vm.alert = $$v
                              },
                              expression: "alert",
                            },
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.skippedEntries) +
                                  " duplicated entries"
                              ),
                            ]),
                            _vm._v(" have been skipped\n                "),
                          ]
                        ),
                        _vm._v(" "),
                        _c("DragUploadBox", {
                          staticClass: "drag-upload-box",
                          attrs: { multiple: "" },
                          on: { uploadedFiles: _vm.upload },
                        }),
                        _vm._v(" "),
                        _vm.queries.length > 0
                          ? _c(
                              "div",
                              { staticClass: "query-chip-group" },
                              _vm._l(_vm.queries, function (q, index) {
                                return _c(
                                  "v-chip",
                                  {
                                    key: q.name,
                                    attrs: {
                                      close: "",
                                      outlined: "",
                                      value: q.name,
                                    },
                                    on: {
                                      "click:close": function ($event) {
                                        return _vm.removeQuery(index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(q.name.split("-_-_-_")[0]) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              }),
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "actions input-buttons-panel" }, [
                      _c(
                        "div",
                        { staticClass: "input-buttons-left" },
                        [
                          _vm.$APP == "foldseek"
                            ? _c("load-acession-button", {
                                attrs: {
                                  "preload-source": _vm.preloadSources,
                                  "preload-accession": _vm.preloadAccessions,
                                  multiple: "",
                                },
                                on: {
                                  select: function ($event) {
                                    return _vm.queries.push(...$event)
                                  },
                                  loading: function ($event) {
                                    _vm.accessionLoading = $event
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("file-button", {
                            attrs: {
                              id: "localFile",
                              label: "Upload previous result (JSON)",
                            },
                            on: { upload: _vm.uploadJSON },
                          }),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn btn--raised btn--file",
                              staticStyle: { position: "relative" },
                              attrs: { type: "button", color: "primary" },
                              on: { click: _vm.handleLoadExample },
                            },
                            [
                              _vm._v(
                                "\n                        Load example MSTA\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c(
                "panel",
                [
                  _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      {
                        staticClass: "actions",
                        style: !_vm.$vuetify.breakpoint.xsOnly
                          ? "display:flex; align-items: center;"
                          : null,
                      },
                      [
                        _c(
                          "v-item-group",
                          { staticClass: "v-btn-toggle" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  block: false,
                                  "x-large": "",
                                  disabled: _vm.alignDisabled,
                                },
                                on: { click: _vm.search },
                              },
                              [
                                _c("v-icon", [_vm._v(_vm._s(_vm.$MDI.Wall))]),
                                _vm._v("\n                     Align"),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            style: !_vm.$vuetify.breakpoint.xsOnly
                              ? "margin-left: 1em;"
                              : "margin-top: 1em;",
                          },
                          [
                            _c("span", [_c("strong", [_vm._v("Summary")])]),
                            _c("br"),
                            _vm._v("\n                Align "),
                            _c("strong", [_vm._v(_vm._s(_vm.queries.length))]),
                            _vm._v(
                              " structures with FoldMason\n                "
                            ),
                            _vm._v(" "),
                            _vm.errorMessage.type
                              ? _c(
                                  "div",
                                  {
                                    class: [
                                      "v-alert",
                                      "v-alert--outlined",
                                      _vm.errorMessage.type + "--text",
                                      "mt-2",
                                    ],
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.errorMessage.message)),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("reference", {
        attrs: { reference: _vm.$STRINGS.CITATION_FOLDMASON },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }